import { CheckoutContextState } from '@Components/ProductDetailPanel/BuyFlow/CheckoutContextState';
import { CheckoutPresenter } from '@Screens/Checkout/presenter';
import { useClassStore } from '@Utils/useClassStore';
import { inject, injectable, postConstruct } from 'inversify';
import { action, computed, reaction } from 'mobx';

import container from '~ioc/ioc';
import { NavigationStore } from '~stores/navigation';

@injectable()
class SideDrawerLeftPresenter {
  @inject(NavigationStore) private navigator2Store!: NavigationStore;
  @inject(CheckoutPresenter) private checkoutPresenter!: CheckoutPresenter;
  @inject(CheckoutContextState)
  private _checkoutContextState!: CheckoutContextState;

  @postConstruct() init() {
    reaction(
      () => this.isOpen,
      () => {
        if (!this.isOpen) {
          this.checkoutPresenter.resetCheckoutFlow();
        }
      }
    );
  }

  @computed get isOpen() {
    return Boolean(this.navigator2Store.currentParams.value?.productId);
  }

  @action close = () => {
    this._checkoutContextState.onCloseButton();
    this.checkoutPresenter.closeModals();
    this.navigator2Store.navToProductId(undefined).then();
  };

  @computed get activeProductId(): number | undefined {
    return this.navigator2Store.currentParams.value?.productId;
  }
}

export const useSideDrawerLeftPresenter = () =>
  useClassStore<SideDrawerLeftPresenter>(
    container.get(SideDrawerLeftPresenter)
  );
